exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".signoutpage-cssmodule-signoutpage-component-1iTOc{margin-top:50px}.signoutpage-cssmodule-error-template-1MqNM{text-align:center}", ""]);

// exports
exports.locals = {
	"signoutpage-component": "signoutpage-cssmodule-signoutpage-component-1iTOc",
	"error-template": "signoutpage-cssmodule-error-template-1MqNM"
};


//////////////////
// WEBPACK FOOTER
// ../~/css-loader?{"modules":true,"importLoaders":1,"localIdentName":"[name]-[local]-[hash:base64:5]"}!../~/postcss-loader!../~/sass-loader!./components/SignOut/signoutpage.cssmodule.scss
// module id = 611
// module chunks = 0